import type { PluginDefaultTranslationsObject } from '../types.js'

export const ru: PluginDefaultTranslationsObject = {
  '@seshuk/payload-storage-bunny': {
    // TUS Upload
    tusUploadChecking: 'Проверка предыдущих загрузок...',
    tusUploadDisableMode: 'Отключить режим TUS',
    tusUploadEnableMode: 'Включить режим TUS',
    tusUploadErrorFileType: 'Тип файла не разрешен',
    tusUploadErrorInitUpload: 'Не удалось инициализировать загрузку',
    tusUploadErrorPrevCheckFail: 'Не удалось проверить предыдущие загрузки',
    tusUploadErrorRestoreUpload: 'Не удалось восстановить загрузку',
    tusUploadFileSize: '{{size}} МБ',
    tusUploadFinalizing: 'Завершение...',
    tusUploadPause: 'Пауза',
    tusUploadPreparing: 'Подготовка загрузки...',
    tusUploadResume: 'Продолжить',
    tusUploadRetry: 'Попробовать снова',
    tusUploadStartOver: 'Начать заново',
    tusUploadStartUpload: 'Начать загрузку',
    tusUploadStatusChecking: 'Проверка предыдущих загрузок...',
    tusUploadStatusCompleted: 'Загрузка успешно завершена!',
    tusUploadStatusFinalizing: 'Завершение загрузки...',
    tusUploadStatusIdle: 'Готово к загрузке',
    tusUploadStatusIdleWithRestore: 'Готово к продолжению или начать заново',
    tusUploadStatusPaused: 'Загрузка приостановлена на {{progress}}%',
    tusUploadStatusUploading: 'Загрузка... {{progress}}%',
    tusUploadTimeHours: 'ч',

    tusUploadTimeMinutes: 'м',
    tusUploadTimeSeconds: 'с',

    // Error messages
    errorAccessDenied: 'У вас нет разрешения на доступ к этому ресурсу',
    errorDeleteFileFailed: 'Не удалось удалить файл: {{filename}}',
    errorMissingRequiredFields: 'Отсутствует необходимая информация',
    errorNoServiceConfigured: 'Не настроена ни одна служба',
    errorStreamConfigMissing: 'Bunny Stream настроен неправильно',
    errorTitleRequired: 'Пожалуйста, введите заголовок для вашего видео',
    errorUploadFileFailed: 'Не удалось загрузить файл: {{filename}}',
  },
}
